import { httpReducer, reduceReducers } from "../lib/create-action";
import {
  getBudgetByDealUUIDActionName,
  getBudgetByCampaignUUIDActionName,
} from "../action_managers/budgets";
import keyBy from "lodash/keyBy";

const initialState = {
  budgetForCampaignUUID: {},
};
const getBudgetByDealUUID = httpReducer(getBudgetByDealUUIDActionName, initialState, {
  success: (state, action) => ({ ...state, ...action.payload.resp }),
  failure: (state, action) => ({ ...state, error: action.payload.error }),
});

const getBudgetByCampaignUUID = httpReducer(getBudgetByCampaignUUIDActionName, initialState, {
  success: (state, action) => ({ ...state, ...keyBy(action.payload.resp, "uuid") }),
  failure: (state, action) => ({ ...state, error: action.payload.error }),
});

export default reduceReducers(getBudgetByDealUUID, getBudgetByCampaignUUID);
